<template>
     <b-container class="d-flex p-0">
        <div v-if="IsEditor" 
            class="d-flex align-items-center my-auto pr-2 h5"> 
            <b-icon-gear 
                style="pointer-events: all; cursor: pointer;" />
                <!-- @click="changeParameter(fieldSet)" /> -->
        </div>
        <b-form-checkbox v-model="Parameter.Selected" plain>{{ Parameter.Label }}</b-form-checkbox>
    </b-container>
</template>

<script lang="ts">

    import { Prop, Vue} from 'vue-property-decorator';
    import Component from 'vue-class-component';
    import VueI18n from 'vue-i18n' // translation support
    import locales from "../locales/ParametersItems.json";
    import CheckBoxField from '../Class/CheckBoxField';

    Vue.use(VueI18n);

    @Component({
        i18n: { messages: locales }
    })
	export default class CheckBoxItem extends Vue{
        /** Variant de couleur à appliquer sur le composant */
        @Prop({default: () => "secondary"})
		public Variant!: string;

        @Prop({default: () => false})
        public IsEditor!: boolean;

        @Prop()
        public Parameter!: CheckBoxField;

        mounted(){
            this.$emit('child-event', 'mounted');
        }

        updated(){
            this.$emit('child-event', 'updated');
        }
    }

</script>

<style scoped>
    :deep(input[type=checkbox]:checked) {
        /** Change la couleur de la checkbox */
        accent-color: var(--Variant) !important;
    }

    :deep(input[type=radio]:checked) {
        /** Change la couleur du bouton radio */
        accent-color: var(--Variant) !important;
    }

    /** Pour que la page active prenne en compte la couleur de Variant */
    :deep(.page-item.active .page-link) {
        background-color: var(--Variant) !important;
    }

    :deep(.page-link:hover) {
        background-color: var(--VariantLight) !important;
    }
</style>